import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { BatteryStat } from 'app/agriculture/components/BatteryStat/BatteryStat';
import { useContext } from 'react';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { PowerDisplaySkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/PowerDisplaySkeleton';

export function PowerDisplay() {
    return (
        <SuspenseWrapper loadingComponent={<PowerDisplaySkeleton />}>
            <WrappedPowerDisplay />
        </SuspenseWrapper>
    );
}

function WrappedPowerDisplay() {
    const { device } = useContext(DeviceDetailContext);
    const { timestamp, batteryStatus, batteryVoltage, batteryCurrent, solarCurrent, solarVoltage } =
        useSnapshot({
            snapshotType: 'Power',
            parentId: device.id,
            shelfLife: { hours: 1 },
        }) ?? {};

    return (
        <ContentBox.Section heading="Power Stats" disableDivider timestamp={timestamp}>
            <SimpleGrid className="PowerDisplay" columns={3}>
                <StatDisplay name="Battery status" value={batteryStatus} />
                <StatDisplay name="Battery current" value={batteryCurrent} unit="mA" />
                <StatDisplay name="Battery voltage" value={batteryVoltage} unit="mV" />
                <BatteryStat name="Battery level" deviceId={device.id} />
                {solarCurrent == null ? null : (
                    <StatDisplay name="Solar current" value={solarCurrent} unit="mA" />
                )}
                <StatDisplay name="Solar voltage" value={solarVoltage} unit="mV" />
            </SimpleGrid>
        </ContentBox.Section>
    );
}
